module.exports = __webpack_public_path__ + "img/icon-restaurant-ads.2bb5f6f5.png";